import IconText from "../Common/Text/IconText";
import IMG from "../../constants/image";
import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import merchantStore from "../../store/merchantStore";
import {ENV} from "../../network/config";
import {isMobile} from "react-device-detect";
import CallButton from "../Common/Button/CallButton";
import BackgroundImage from "./BackgroundImage";
import HeaderLogin from "./HeaderLogin";
import {clsx} from "clsx";
import HeaderHome from "./HeaderHome";
import appStore from "../../store/appStore";

const headerHorizontalPadding =
  'px-4 sm:px-6 md:px-10 lg:px-16 xl:px-32';

const TopHeading = () => {
  const {merchantProfile} = merchantStore() || {};
  const {setFromNativeApp} = appStore();
  useEffect(() => {
    if (typeof window !== 'undefined' && window?.ReactNativeWebView) {
      setFromNativeApp(true)
    }
  }, []);
  if (isMobile) return (
    <div className='bg-primary md:h-12 md:px-32'>
      <div className={clsx(' w-full z-10  bg-[#197D55] flex items-center justify-center')}>
        <BackgroundImage
          src={IMG.background.abstract}
          srcMobile={IMG.background.abstract}
          alt="Login Info Graphic"
        />
        {!merchantProfile?.id ? <HeaderLogin/> : <HeaderHome/>}
      </div>
    </div>

  )

  return (
    <div className={clsx('w-full bg-primary md:h-12', headerHorizontalPadding)}>
      <div className='hidden md:flex w-full min-w-0 justify-between items-center h-full'>
        <div className='left text-white marquee'>
          <IconText
            className='child-mar'
            icon={IMG.icon.truck}
            iconClass='w-6 h-6'
            text='Phiên bản thử nghiệm'
          />
        </div>
        <div className='right flex justify-center items-center gap-[30px] text-white'>
          <div>
            <Link className='cursor-pointer' to={`${ENV.FUNONG_DOMAIN}/tin-tuc`} target='_blank'>
              <IconText
                icon={IMG.icon.newsLight}
                iconClass='w-[22px]'
                text='Tin tức nông nghiệp'
              />
            </Link>
          </div>
          <div>
            <IconText
              icon={IMG.icon.phoneLight}
              iconClass='w-6'
              textChild={(
                <CallButton text='Hotline: ' phoneNumber="033 959 6667"/>
              )}
            />
          </div>
        </div>
      </div>
    </div>

  )
}
export default TopHeading
